module.exports = __webpack_public_path__ + "media/images/country_flags/tz-d3b9d39fe53d445a6c6d7840938717d6.png";